// extracted by mini-css-extract-plugin
export default {"emailHtml":"EmailHtmlBody_emailHtml__0vjgh","quoteToggle":"EmailHtmlBody_quoteToggle__WSm25","quotedHistory":"EmailHtmlBody_quotedHistory__TGxrL"};